export default "__VITE_ASSET__3bd20b44__"